import Component from "@glimmer/component";
import { service } from "@ember/service";
import { task } from "ember-concurrency";
import { sshKeyRemove } from "glesys-controlpanel/data/ssh-key/builders";

export default class ModalsSshKeysManage extends Component {
  @service modal;
  @service store;

  get sshKeys() {
    return this.args.params.sshKeys;
  }

  get project() {
    return this.args.params.project;
  }

  deleteSshKey = task(async (key) => {
    await this.store.request(sshKeyRemove(key));
  });
}
